<template>
  <span>
    <template v-for="(sentence, index) in this.sentences">
      <template v-if="sentence.startsWith('link!')">
        <a @click.stop="link(linkContents(sentence, 1))" :key="index">{{
          linkContents(sentence, 0)
        }}</a>
      </template>
      <span v-else :key="index" v-html="sentence" />
    </template>
  </span>
</template>

<script>
import { mapActions } from 'vuex'
import { FactoryTrack } from '@/constant/firebase'

const LINK_TAG = 'link!'
export default {
  name: 'AccordionText',
  props: {
    line: { type: String, required: true },
    innerPageLink: {
      type: Function,
      memo: '大本のFAQWalkFAQから受け取ったページ内リンクをするファンクション'
    }
  },
  created() {
    this.sentences = this.line
      .replace('[[[', `@@@${LINK_TAG}`)
      .replace(']]]', `@@@`)
      .split('@@@')
  },

  computed: {
    details: function() {
      return this.ans.split('<br>').map(item => `${item}<br>`)
    }
  },
  data() {
    return {
      sentences: ''
    }
  },
  methods: {
    ...mapActions('Native', ['actionRequestExternalLink']),
    ...mapActions('Analytics', ['trackEvent']),
    linkContents(str, index) {
      const datas = str
        .replace(LINK_TAG, '')
        .replace(']]]', '')
        .split(':::')

      return datas[index]
    },
    link(linkStr) {
      if (linkStr.startsWith('inner/')) {
        this.innerPageLink(linkStr.replace('inner/', ''))
      } else if (linkStr.startsWith('ex/')) {
        this.trackEvent(FactoryTrack.createExternalLink(linkStr.replace('ex/', '')))
        console.log(linkStr.replace('ex/', ''))
        this.actionRequestExternalLink(linkStr.replace('ex/', ''))
        return false
      } else {
        this.trackEvent(FactoryTrack.createLink(linkStr))
        this.$router.push(linkStr)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: underline;
}
</style>
